import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { UserService } from "../../services";
import { Button } from "../shared";
import { useAppNavigation } from "../../hooks";
import BranchSlotPicker from "../shared/BranchSlotPicker";

const ScheduleCarPickupModal = ({ show, closeModal, carDetails, setLoader }) => {
  const { t } = useTranslation();
  const { toSuccessScreen } = useAppNavigation();

  const branchCode = !show || !Object.keys(carDetails).length ? null : carDetails.branchCode;

  const [selectedDay, setSelectedDay] = useState("");

  const validationSchema = () => {
    return Yup.object().shape({
      scheduleTime: Yup.string().required(t("track.selectDateTime"))
    });
  };

  const handleSubmit = async (values) => {
    setLoader(true);
    try {
      const payload = {
        ...values,
        phoneNumber: carDetails?.phoneNumber,
        carPlateNumber: carDetails?.carPlateNumber,
        date: selectedDay,
        branchCode: carDetails?.branchCode,
        make: carDetails?.make,
        model: carDetails?.model,
        year: carDetails?.year || "",
        appointmentId: carDetails?.appointmentId
      };
      const response = await UserService.scheduleCarCollection(payload);
      if (response?.message === "success.savedSlot") {
        setLoader(false);
        closeModal();
        toSuccessScreen({ from: "car-pickup" });
      }
    } catch (err) {
      setLoader(false);
      console.error(err);
    }
  };

  const cancelPickup = () => {
    setSelectedDay("");
    closeModal();
  };

  return (
    <>
      <Modal show={show} onHide={closeModal} centered={true} backdrop="static">
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={{
              scheduleTime: ""
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}>
            {(formikProps) => (
              <Form>
                <div className="vehicle-collection-schedule">
                  <h4 className="title_form">{t("track.scheduleYourCarPickup")}</h4>
                  <p className="text-center">
                    Select from available dates and time slots to collect your vehicle from center
                  </p>
                  <BranchSlotPicker
                    parentClassName="my-4"
                    branchSelector={{ key: "branchCode", value: branchCode }}
                    selectedDay={selectedDay}
                    setSelectedDay={setSelectedDay}
                    formikProps={formikProps}
                  />

                  <div className="text-center">
                    <Button type="small-roundedLeft" customize="secondary" action={cancelPickup}>
                      {t("track.cancelClose")}
                    </Button>
                    <input
                      type="submit"
                      value={t("track.bookCar")}
                      className="ah-btn btn primary-btn rounded-right m-0"
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default React.memo(ScheduleCarPickupModal);
